import React from 'react';
import { BOTTLE_SIZES, sizeLabel } from '../constants/bottleSizes';

export default function SizeSelector({ value, onChange }) {
  return (
    <div className="mb-6">
      <div className="flex items-baseline justify-between gap-3 mb-2.5">
        <p className="text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-[#1A2332]/70">Size</p>
        <p className="text-[11px] text-[#1A2332]/50">{sizeLabel(value)} extrait</p>
      </div>
      <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Bottle size">
        {BOTTLE_SIZES.map((size) => {
          const selected = value === size.ml;
          const available = size.available;
          return (
            <button
              key={size.ml}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-disabled={!available}
              disabled={!available}
              onClick={() => available && onChange(size.ml)}
              className={`relative min-h-[3.5rem] px-2 py-2.5 border text-center transition-colors touch-manipulation ${
                selected
                  ? 'border-[#1A2332] bg-[#1A2332] text-[#F5EFE6]'
                  : available
                    ? 'border-[#1A2332]/20 bg-white/50 text-[#1A2332] hover:border-[#1A2332]/50'
                    : 'border-[#E5DCC9] bg-[#F5EFE6] text-[#1A2332]/35 cursor-not-allowed'
              }`}
            >
              <span className="block font-serif-display text-lg leading-none">{size.ml}</span>
              <span className="block mt-1 text-[9px] tracking-[0.18em] uppercase">
                {available ? 'ML' : 'Soon'}
              </span>
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-[11px] text-[#1A2332]/50">20 ML and 30 ML bottles launch soon.</p>
    </div>
  );
}
